/**
 * Route types
 */
export enum RouteType {
    VISITOR = 'VISITOR',
    /**
     * @deprecated  `CONTRACT` type is now useless in ONE-i mode, you can remove it.
     */
    CONTRACT = 'CONTRACT',
    /**
     * @deprecated  `ACCOUNT` type is now useless in ONE-i mode, you can remove it.
     */
    ACCOUNT = 'ACCOUNT',
    /**
     * @deprecated  `ONE` type is now useless in ONE-i mode, you can remove it.
     */
    ONE = 'ONE',
}
